import axiosRetry from 'axios-retry'

import Api from './Api'

axiosRetry(Api.instance, {
  retries: 3,
  retryDelay: (retryCount: any) => {
    return retryCount * 1000
  },
})

export default Api.instance
